import React, { useContext } from "react";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CollapseComponent from '../../components/Schedule/CollapseComponent';
import AuthContext from "../../context/AuthContext";

const FullViewComponent = (props) => {
  const { showDay, onRowSelectionModelChange, SelectedEmp, expandAll, handleExpandChange, permission,
    onOpenModal, anyExpanded, handleRightClick, dayData, reformatColumns, is_dn_deparment , enableMultiSelect } = props
  
  const { v3Data } = useContext(AuthContext);

  return (
    <div onContextMenu={handleRightClick}
      style={{
        borderBottom: '1px solid #cccccc',
      }}>
      <Grid container>
        <Grid item xs={12} sx={{ pr: 1 }}>
          <Box>
            {showDay && dayData && dayData.dayEmployee &&
              Object.values(dayData.dayEmployee).map((station) => (
                <CollapseComponent
                  key={station.name}
                  rows={station.employees}
                  columns={reformatColumns(station.notAbsentDay, station.totalDay , station.minStaffDay)}
                  name={station.name}
                  onRowSelectionModelChange={onRowSelectionModelChange}
                  rowSelectionModel={SelectedEmp}
                  open={expandAll}
                  onExpandChange={handleExpandChange}
                  checkboxSelection={(permission?.includes('Emp_Auth') && (v3Data?.V3_DEFAULT_MULTI_CHECKBOX_SCHEDULE ? enableMultiSelect : true)) ? true : false}
                  onOpenModal={onOpenModal}
                  showHeader={false}
                  showAllColumn={true}
                  is_dn_deparment={is_dn_deparment}
                  page = {'schedule-page'}
                />
              ))
            }
            {dayData && dayData.stations &&
              Object.values(dayData.stations).map((station) => (
                <CollapseComponent
                  key={station.name}
                  rows={station.employees}
                  columns={reformatColumns(station.notAbsentDay, station.totalDay, station.notAbsentNight, station.totalNight, true , station.minStaffDay,  station.minStaffNight)}
                  name={station.name}
                  onRowSelectionModelChange={onRowSelectionModelChange}
                  rowSelectionModel={SelectedEmp}
                  open={Object.keys(dayData.stations).length < 1 ? true : false || expandAll}
                  minHeightRow='auto'
                  onExpandChange={handleExpandChange}
                  checkboxSelection={(permission?.includes('Emp_Auth') && (v3Data?.V3_DEFAULT_MULTI_CHECKBOX_SCHEDULE ? enableMultiSelect : true)) ? true : false}
                  onOpenModal={onOpenModal}
                  showHeader={false}
                  showAllColumn={true}
                  is_dn_deparment={is_dn_deparment}
                  page = {'schedule-page'}
                  minimumDayStaff = {station.minStaffDay}
                  minimumNightStaff = {station.minStaffNight}
                />
              ))}
          </Box>
        </Grid>
      </Grid>
    </div>
  )
}

export default FullViewComponent;


